import { DeductionType, DeductionTemplateDto } from '@generatedTypes/data-contracts';
import { useTranslations } from '@services/hooks/translations/useTranslations';
import { ListItem } from '@components/ListMui/ListItem';
import { Stack, Typography } from '@mui/material';
import { getFormattedNumber } from '@pages/NewLeads/utils';

type DeductionTemplatesListContentProps = {
  deductions: DeductionTemplateDto[];
  onShowAddEditDeductionForm?: (projectDeductionId?: number) => void;
};

export const DeductionTemplatesListContent: React.FC<DeductionTemplatesListContentProps> = ({
  deductions,
  onShowAddEditDeductionForm,
}) => {
  const {
    translate,
    translations: {
      common: { units },
    },
  } = useTranslations();

  return (
    <>
      {deductions.map(({ id, name, type, value }) => (
        <ListItem
          sx={{ paddingInlineStart: 3 }}
          key={id}
          title={
            <Stack direction="row" width={`80%`} justifyContent="space-between">
              <Typography>{name}</Typography>
            </Stack>
          }
          onClick={() => onShowAddEditDeductionForm?.(id)}
          secondaryAction={
            <Stack direction="column">
              <Typography noWrap textAlign="right">
                {type === DeductionType.Sum
                  ? `- ${getFormattedNumber(value, translate(units.currencyCrowns))}`
                  : `${value}%`}
              </Typography>
            </Stack>
          }
        />
      ))}
    </>
  );
};
